import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectHistory } from "./ui";

export const ProjectHistoryRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.general.history()}`,
    element: createElement(ProjectHistory),
    children: [...rest],
  };
};
